<div class="container">
  <img src="assets/images/logo-color.png" alt="purelatte-logo">
  <h1 class="404-title">{{'NOT_AUTHORIZED.TITLE' | i18next}}</h1>
  <h3>{{'NOT_AUTHORIZED.MESSAGE' | i18next}}</h3>
  <a (click)="logout()">{{'NOT_AUTHORIZED.LOGOUT' | i18next}}</a>
</div>

